import { Pipe, PipeTransform } from '@angular/core';
import { ToleranzenBezeichnungen, ZählerName, ZählerWert } from './zaehler.types';
import { defaultTolBez, matchTolOption } from './zaehler.enums';

@Pipe({
  name: 'transformColNames',
})
export class TransformColNamesPipe implements PipeTransform {
  transform(col: string, tol: ToleranzenBezeichnungen, isMessGeraetOptionOn?: boolean): string {
    const colName = col as keyof ZählerWert | keyof ZählerName;
    tol ??= defaultTolBez;
    if (colName == 'ZType' && !isMessGeraetOptionOn) return 'Header';
    const optionName: keyof ToleranzenBezeichnungen = matchTolOption[colName];
    if (optionName) return tol[optionName] ?? defaultTolBez[optionName];
    return colName;
  }
}
